/* global Office */

import { OfficeEnvironment } from "@/types/document";

class OfficeSettingsSingleton {
  private _environment: OfficeEnvironment | undefined = undefined;

  constructor() {
    Office.onReady(() => {
      this._environment =
        `${Office.context.platform}`.match(/online/gi) === null ? OfficeEnvironment.Desktop : OfficeEnvironment.Online;
    });
  }

  public get environment() {
    if (this._environment === undefined) {
      this._environment =
        `${Office.context.platform}`.match(/online/gi) === null ? OfficeEnvironment.Desktop : OfficeEnvironment.Online;
    }
    return this._environment;
  }

  public set environment(env: OfficeEnvironment) {
    this._environment = env;
  }
}

const OfficeSettings = new OfficeSettingsSingleton();

export default OfficeSettings;
